/**
 * SEPA Mandate Routes
 *
 * Route definitions for the SEPA mandates module.
 */

import { lazy } from 'react';

const SEPAMandateManagement = lazy(() => import('@/pages/sepa-mandates/SEPAMandateManagement'));

export const sepaMandateRoutes = [
    {
        path: 'sepa-mandates',
        element: <SEPAMandateManagement />,
    },
];
